export const ROOT = '/OnboardingAPI';
export const EMAILPREVIEWROOT = '/EmailPreviewAPI';
export const DETAILS = `${ROOT}/getonboarding`;
export const LIST = `${ROOT}/getonboardinglist`;
export const TRAINING = `${ROOT}/trainingnameddl`;
export const CATEGORY = `${ROOT}/gettrainingcategory`;
export const PARTICIPANT = `${ROOT}/Participants`;
export const TRAINEE = `${ROOT}/trainee`;
export const ATTENDANCE = `${ROOT}/attendance`;
export const GET_HOLIDAY_DATES = `${ROOT}/getholidaydates`;
export const EXPORT_ONBOARDING_LIST = `${ROOT}/exportoblist`;
export const EXPORT_ATTENDANCE = `${ROOT}/exportobparticipants`;
export const EXPORT_ONBOARDING_DETAILS = `${ROOT}/exportobdetails`;
export const RESEND = `${ROOT}/resendfacilitatorlink`;
export const GET_ONBOARDING_ADD_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getonboardingaddemail`;
export const CREATE_ONBOARDING_ADD_WITH_EMAIL = `${ROOT}/createonboardingaddwithemail`;
export const GET_ONBOARDING_DETAIL_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getonboardingdetailemail`;
export const UPDATE_ONBOARDING_DETAIL_WITH_EMAIL = `${ROOT}/updateonboardingdetailwithemail`;
